<template>
  <vx-modal :title="$t('MODALS.flex.title')">
    <template v-slot:body>
      <div class="px-2 mb-5 pb-5" style="height: 400px; overflow-y: auto">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="start" vs-lg="5" vs-sm="12" vs-xs="12" class="p-3">
            <vs-row>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <feather-icon icon="RotateCwIcon" svgClasses="h-4 w-4 cursor-pointer" />
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <div class="w-full">
                  <h6>{{ $t("MODALS.flex.selectQuestion") }}</h6>
                  <select class="select px-2" v-model="option">
                    <option :value="option.id" v-for="(option, index) in Lista" :key="index">
                      <div class="py-5">
                        {{ option.label }}
                      </div>
                    </option>
                  </select>
                </div>
              </vs-col>
              <vs-col
                class="mt-4"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <div class="w-full">
                  <h6>{{ $t("MODALS.flex.selectOptions") }}</h6>
                  <select class="select px-2" v-model="label">
                    <option :value="option" v-for="(option, index) in listOptions" :key="index">
                      <div class="py-5">
                        {{ option }}
                      </div>
                    </option>
                  </select>
                </div>
              </vs-col>
              <vs-col
                class="mt-4"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <div class="w-full">
                  <h6>{{ $t("MODALS.flex.component") }}</h6>
                  <v-select
                    class="w-full"
                    v-model="typeQuestion"
                    :options="inputTypes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  />
                  <span v-show="false">{{ WichComponent }}</span>
                </div>
              </vs-col>
              <vs-col
                v-if="conditionAdd"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <component
                  :is="WichComponent"
                  :properties="newComponent.properties"
                  :inputType="newComponent.inputType"
                ></component>
              </vs-col>
              <vs-col
                v-if="conditionAddBtn"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
              >
                <div
                  @click="!conditionAddBtn ? null : addQuestion()"
                  class="
                    item-view-secondary-action-btn
                    mx-4
                    my-3
                    p-3
                    flex flex-grow
                    items-center
                    justify-center
                    text-white
                    cursor-pointer
                    rounded
                  "
                  :class="'btn-active'"
                >
                  <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                  <span class="text-sm font-semibold ml-2">{{ $t("MODALS.flex.btnAddQuestion") }}</span>
                </div>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="7" vs-sm="12" vs-xs="12" class="p-3">
            <table class="w-full">
              <tr class="px-5">
                <th>{{ $t("MODALS.flex.Id") }}</th>
                <th>{{ $t("MODALS.flex.description") }}</th>
                <th>{{ $t("MODALS.flex.typeComponent") }}</th>
                <th class="text-center">{{ $t("MODALS.flex.delete") }}</th>
              </tr>
              <draggable :list="answersTable" tag="tbody" class="cursor-move">
                <tr v-for="(tr, indextr) in answersTable" class="tr" :key="indextr">
                  <td class="p-2">
                    {{ tr.name }}
                  </td>
                  <td class="p-2">
                    {{ tr.label }}
                  </td>
                  <td class="p-2">
                    {{ $t(`INPUTTYPE.${tr.type}.${tr.inputType}`) }}
                  </td>
                  <td class="p-2 flex justify-center">
                    <vs-button
                      color="danger"
                      type="border"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="deleteQuestion(tr)"
                    ></vs-button>
                  </td>
                </tr>
              </draggable>
            </table>
          </vs-col>
        </vs-row>
      </div>
    </template>
  </vx-modal>
</template>
<script type="text/javascript">
import draggable from "vuedraggable";
import vSelect from "vue-select";
import { mapState } from "vuex";
import { setQuestion } from "../../indexDB/logic.js";

import { clasesQuestions } from "../../provider/clases-questions.js";
import { ComponentesFlex } from "./components-flex.vue/index.js";
export default {
  components: { draggable, vSelect, ...ComponentesFlex },
  async mounted() {
    await this.toFullQuestions();
  },
  beforeDestroy() {
    setQuestion();
  },
  data() {
    return {
      label: "",
      typeQuestion: "",
      newComponent: null,
      InputF: ["default", "textarea", "email"],
      NumberF: ["currency", "number"],
      PasswordF: ["password", "phone"],
      QrF: ["QRReader"],
      Lista: [],
      inputTypes: [
        {
          id: "default",
          label: this.$t(`INPUTTYPE.input.default`)
        },
        {
          id: "currency",
          label: this.$t(`INPUTTYPE.input.currency`)
        },
        {
          id: "email",
          label: this.$t(`INPUTTYPE.input.email`)
        },
        {
          id: "number",
          label: this.$t(`INPUTTYPE.input.number`)
        },
        {
          id: "password",
          label: this.$t(`INPUTTYPE.input.password`)
        },
        {
          id: "phone",
          label: this.$t(`INPUTTYPE.input.phone`)
        },
        {
          id: "textarea",
          label: this.$t(`INPUTTYPE.input.textarea`)
        },
        {
          id: "QRReader",
          label: this.$t(`INPUTTYPE.input.QRReader`)
        }
      ]
    };
  },
  methods: {
    /**
     * Obtiene la lsita de preguntas de tipo multiple y radio para el combobox del flexible.
     */
    async toFullQuestions() {
      const index = this.AllQuestions.findIndex(question => question.name === this.question.name);
      const newList = [...this.AllQuestions].slice(0, index);
      this.Lista = newList
        .filter(question => question.inputType === "multi" || question.inputType === "radio")
        .map(question => {
          return {
            id: question.name,
            label: question.label
          };
        });
    },
    /**
     * Resetea las propiedades inherited y answers.
     */
    resetear() {
      this.questionsByPage[this.indexQuestion].inherited = [];
      this.questionsByPage[this.indexQuestion].related.answers = [];
    },
    getName() {
      if (this.question) {
        if (this.answersTable.length === 0) return this.question.name + "_0";
        const names = this.answersTable.map(question => parseInt(question.name.split("_")[2]));
        const valor = Math.max(...names) + 1;
        return this.question.name + "_" + valor;
      }
    },
    /**
     * Agrega los componentes al flexible juntomcon sus propiedades.
     */
    addQuestion() {
      this.questionsByPage[this.indexQuestion].inherited.push(this.newComponent);
      this.questionsByPage[this.indexQuestion].related.answers.push(this.label);
      this.label = "";
      this.typeQuestion = "";
    },
    /**
     * Elimina ubn componente de la lista del inherited del flexible
     * @param { Object } tr
     */
    deleteQuestion(tr) {
      const inherited = this.questionsByPage[this.indexQuestion].inherited;
      const answers = this.questionsByPage[this.indexQuestion].related.answers;
      this.questionsByPage[this.indexQuestion].inherited = inherited.filter(question => question.label !== tr.label);
      this.questionsByPage[this.indexQuestion].related.answers = answers.filter(answer => answer !== tr.label);
    }
  },
  computed: {
    ...mapState("resource", ["indexQuestion", "questionsByPage", "AllQuestions"]),
    /**
     * Obtiene la lista de opciones para la propiedad answers del flexible
     */
    listOptions() {
      if (this.option !== "") {
        const element = this.AllQuestions.find(question => question.name === this.option);
        const inherited = this.answersTable.map(question => question.label);
        const filterOptions = [...new Set(element.options)].filter(option => !inherited.includes(option));
        return filterOptions;
      }
      return [];
    },
    conditionAdd() {
      if (this.label === undefined) return false;
      if (this.typeQuestion === "") return false;
      return this.label.trim().length > 0 && this.typeQuestion.id !== "email";
    },
    conditionAddBtn() {
      if (this.label === undefined) return false;
      return this.label.trim().length > 0 && this.typeQuestion !== "";
    },
    question() {
      return this.questionsByPage[this.indexQuestion];
    },
    /**
     * Obtiene la lista de componentes del inherited para pintar en la tabla
     */
    answersTable() {
      return this.question.inherited;
    },
    option: {
      get() {
        if (this.question.related.question === -1) return "";
        const question = this.AllQuestions.find(question => question.name === this.question.related.name);
        return question.name;
      },
      set(value) {
        if (value !== null) {
          const related = {
            name: value,
            question: this.AllQuestions.findIndex(question => question.name === value),
            relatedness: "multiple",
            answers: []
          };
          this.questionsByPage[this.indexQuestion].inherited = [];
          this.questionsByPage[this.indexQuestion].related = related;
        } else {
          const related = {
            name: this.question.name,
            question: -1,
            relatedness: "multiple",
            answers: []
          };
          this.questionsByPage[this.indexQuestion].related = related;
          this.resetear();
          this.toFullQuestions();
        }
      }
    },
    WichComponent() {

      if (this.QrF.includes(this.typeQuestion.id)) {
        const element = clasesQuestions["standar"]["qr"];
        const funcion = element[this.typeQuestion.id];
        const result = funcion(this.getName(), this.label);
        this.newComponent = result;
        this.newComponent.help = "N/A";
        return "";
      }

      if (this.InputF.includes(this.typeQuestion.id)) {
        const element = clasesQuestions["standar"]["input"];
        const funcion = element[this.typeQuestion.id];
        const result = funcion(this.getName(), this.label);

        if (this.typeQuestion.id === "email") {
          this.newComponent = result;
          this.newComponent.help = "N/A";
          return "";
        }
        this.newComponent = result;
        this.newComponent.help = "N/A";
        return "InputF";
      }

      if (this.NumberF.includes(this.typeQuestion.id)) {
        const element = clasesQuestions["standar"]["number"];
        const funcion = element[this.typeQuestion.id];
        const result = funcion(this.getName(), this.label);
        this.newComponent = result;
        this.newComponent.help = "N/A";
        return "NumberF";
      }

      if (this.PasswordF.includes(this.typeQuestion.id)) {
        const element = clasesQuestions["standar"]["input"];
        const funcion = element[this.typeQuestion.id];
        const result = funcion(this.getName(), this.label);
        this.newComponent = result;
        this.newComponent.help = "N/A";
        return "PasswordF";
      }
    }
  }
};
</script>
<style type="text/css" scoped>
.select {
  width: 100%;
  height: 36px;
  border-radius: 3px;
  border: 1px solid rgba(60, 60, 60, 0.26);
  color: #626262;
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
}
table,
th,
td {
  border-collapse: collapse;
  border-color: #f2f2f2;
}

.tr td {
  padding-top: 55px;
}

.tr:nth-child(2n) {
  background: #f2f2f2;
  border-color: #f2f2f2;
}
</style>
